import { Reveal, Chapter } from './Reveal';

const BENEFITS = [
  { img: '/assets/ben-mentalidade.webp', title: 'Mentalidade Inabalável', desc: 'Resiliência para não abandonar o processo no primeiro obstáculo.' },
  { img: '/assets/ben-foco.webp', title: 'Foco Laser', desc: 'Menos distrações, mais execução no que realmente importa.' },
  { img: '/assets/ben-rotina.webp', title: 'Rotina de Elite', desc: 'Estruture manhãs e noites que trabalham a seu favor.' },
  { img: '/assets/ben-tempo.webp', title: 'Domínio do Tempo', desc: 'Prioridades claras e dias que rendem de verdade.' },
  { img: '/assets/ben-consistencia.webp', title: 'Consistência Diária', desc: 'Pequenas vitórias repetidas até virarem identidade.' },
  { img: '/assets/ben-proposito.webp', title: 'Clareza de Propósito', desc: 'Saiba exatamente por que você acorda cedo todos os dias.' },
];

export const Benefits = () => (
  <section data-testid="benefits-section" className="relative border-t border-white/5 bg-[#060606]">
    <div className="mx-auto max-w-6xl px-6 py-24 sm:px-10 sm:py-36">
      <Chapter index="03" label="Benefícios" />

      <Reveal>
        <h2 className="max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          O que muda quando você <span className="text-gold">desperta.</span>
        </h2>
      </Reveal>

      <div data-testid="benefits-grid" className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={0.06 * i} y={22}>
            <div className="group h-full rounded-2xl border border-white/[0.07] bg-graphite p-6 transition-colors duration-300 hover:border-gold/40">
              <div className="mb-5 h-14 w-14 overflow-hidden rounded-full shadow-[0_0_25px_rgba(212,175,55,0.15)] transition-transform duration-300 group-hover:scale-110">
                <img src={b.img} alt={`Símbolo de ${b.title}`} loading="lazy" className="h-full w-full object-cover" />
              </div>
              <h3 className="font-display text-lg font-semibold text-white">{b.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-400">{b.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
